import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";

var _class, _descriptor, _temp;

import { action, observable } from "mobx";
import { Page } from "../models/page";
/* istanbul ignore next: Example implementations gets deleted the most time after plugin creation! */

var PageStore = (_class = (_temp = /*#__PURE__*/function () {
  function PageStore(rootStore) {
    _classCallCheck(this, PageStore);

    _initializerDefineProperty(this, "page", _descriptor, this);

    this.rootStore = void 0;
    this.rootStore = rootStore;
  }

  _createClass(PageStore, [{
    key: "setPage",
    value: function setPage(page) {
      this.page = page;
    }
  }]);

  return PageStore;
}(), _temp), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "page", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return Page.LANDING;
  }
}), _applyDecoratedDescriptor(_class.prototype, "setPage", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setPage"), _class.prototype)), _class);
export { PageStore };